export default __webpack_public_path__ + "static/media/jade.75916c93.jpeg";